import { Reports } from '@core/models/reports/reports.models';
import dayjs from 'dayjs';
import localforage from 'localforage';

const REPORT_RETENTION_DAYS = 7;

export const removeReportFromIndexedDB = async (
  report: Reports.ReportQueryData,
  workspaceId: string
) => {
  const IDBKey = report.report_id
    ? `report_${workspaceId}_${report.type}_${report.report_id}`
    : `report_${workspaceId}_${report.type}_${report.generated_at}`;
  await localforage.removeItem(IDBKey);
};

export const storeReportOnIndexedDB = async (
  report: Reports.ReportQueryData,
  workspaceId: string
) => {
  const IDBKey = report.report_id
    ? `report_${workspaceId}_${report.type}_${report.report_id}`
    : `report_${workspaceId}_${report.type}_${report.generated_at}`;
  await localforage.setItem(IDBKey, report);
};

export const getReportsFromIndexedDB = async (
  workspaceId?: string
): Promise<Reports.ReportQueryData[]> => {
  const keyPrefix = workspaceId ? `report_${workspaceId}_` : `report_`;
  const allKeys = await localforage.keys();
  const matchingKeys = allKeys.filter((key) => key.startsWith(keyPrefix));

  const reports: Reports.ReportQueryData[] = [];
  const keysToRemove: string[] = [];
  const expirationDate = dayjs().subtract(REPORT_RETENTION_DAYS, 'days');

  for (const key of matchingKeys) {
    const report = await localforage.getItem<Reports.ReportQueryData>(key);

    if (report) {
      if (report.generated_at && dayjs(report.generated_at).isBefore(expirationDate)) {
        keysToRemove.push(key);
      } else {
        const backfilled = report.workspace_id
          ? report
          : { ...report, workspace_id: key.split('_')[1] };
        reports.push(backfilled);
      }
    }
  }

  for (const key of keysToRemove) {
    await localforage.removeItem(key);
  }

  return reports;
};
